import { render, staticRenderFns } from "./RpaUltra.vue?vue&type=template&id=296e4c8c&scoped=true&"
import script from "./RpaUltra.vue?vue&type=script&lang=js&"
export * from "./RpaUltra.vue?vue&type=script&lang=js&"
import style0 from "./RpaUltra.vue?vue&type=style&index=0&id=296e4c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e4c8c",
  null
  
)

export default component.exports